import { ConcreteEncodable } from "./ConcreteEncodable";

import { PositionBookFetchResponseImplEncoder } from "../../encoder/PositionBookFetchResponseImplEncoder";

import * as CubiqTS from "../../index";
import { PositionBookFetchResponse } from "../PositionBookFetchResponse";

export class PositionBookFetchResponseImpl
  extends ConcreteEncodable
  implements PositionBookFetchResponse
{
  public static enType: string = "com.bcdfx.model.PositionBookFetchResponseImpl";

  /*FID=1*/
  public positionBooks: CubiqTS.PositionBookPairInfo | null = null;
  /*FID=2*/
  public componentPositionBooks: Array<CubiqTS.PositionBookPairInfo> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = PositionBookFetchResponseImplEncoder.Instance;
    this.setEncodableType(PositionBookFetchResponseImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "PositionBookFetchResponseImpl[" +
      "positionBooks=" +
      this.positionBooks +
      "componentPositionBooks=" +
      this.componentPositionBooks +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
